import React from 'react';

import { Piwik } from '@eika-kortbetjening/types';

import './CreditBar.scss';

interface CreditBarProps {
    balance: number;
    creditLimit: number;
    piwik: Piwik | undefined;
}

const getPercentageFraction = (numerator: number, denominator: number): number => {
    if (denominator === 0) {
        return 0;
    }

    return (numerator / denominator) * 100;
};

export const CreditBar = ({ balance, creditLimit, piwik }: CreditBarProps) => {
    const availablePercentage = getPercentageFraction(balance, creditLimit);

    return (
        <div
            aria-hidden="true"
            className="credit-bar"
            data-track-id={piwik?.transactions?.availableCreditBar?.dataTrackId}
            data-track-linkname={piwik?.transactions?.availableCreditBar?.dataTrackLinkname}
            id={piwik?.transactions?.availableCreditBar?.dataTrackId}
        >
            <div style={{ width: `${availablePercentage}%` }} />
        </div>
    );
};
